<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
              <p class="text-h4 text--primary">
                  <TextHeading :level=3>Nasze Szkolenia</TextHeading>
              </p>
              <span v-for="(paragraph, i) in paragraphs"
                    :key="i">
                    <p class="text--primary">
                        <TextHeading :level=5>{{ paragraph.title }}</TextHeading>
                    </p>
                    <span v-for="(section, j) in paragraph.sections" :key="j">
                        <div v-if="section.type == 'paragraph'" :id="section.cssId" class="text-body-1 text--primary" v-html="section.text"></div>
                        <p v-if="section.type == 'special_paragraph'" class="text--primary">
                            <TextHeading :level=6>{{ section.text }}</TextHeading>
                        </p>
                        <span v-if="section.type == 'list'">
                            <div class="text-body-1 text--primary" v-html="section.text"></div>
                            <v-list dense disabled>
                                <v-list-item
                                    v-for="(point, k) in section.points"
                                    :key="k"
                                >
                                    <v-list-item-icon>
                                        <v-icon>{{ section.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title ><span class="text-wrap text-body-1" v-html="point"></span></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </span>
                        <br />
                    </span>
                </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},
  
    data: () => ({
      paragraphs: [
        {
            title: "",
            sections: [
                {
                    text: "Zobacz referencje, który uzyskaliśmy od naszych klientów.",
                    type: "list",
                    icon: "",
                    points: [
                      "1. Szkolenie pn. „Tworzenie i administrowanie stronami i aplikacjami internetowymi oraz bazami danych” - w ramach projektu nr RPZP.08.06.00-32-K061/17;",
                      "2. Szkolenie pn. „Administracja i eksploatacja systemów komputerowych, urządzeń peryferyjnych i lokalnych sieci komputerowych” - w ramach projektu nr RPZP.08.06.00-32-K061/17;",
                      "3. Szkolenie pn. „Organizacja małych zespołów” - w ramach projektu nr RPZP.08.06.00-32-K061/17;"
                    ]
                },
            ]
        },
      ]
    }),
  }
  </script>
  